var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { margin: "0 20px" } }, [
    _c(
      "div",
      { staticClass: "showImageBox", style: { height: _vm.height + "px" } },
      [
        _c("span", { staticClass: "title" }, [_vm._v(_vm._s(_vm.code))]),
        _vm.url
          ? _c("el-image", {
              staticStyle: { width: "100%", height: "100%" },
              attrs: {
                src: _vm.url,
                "preview-src-list": _vm.srcList,
                fit: "scale-down",
              },
            })
          : _c("el-empty", { attrs: { description: "暂无图片" } }),
      ],
      1
    ),
    _vm.imageArray.length > 0
      ? _c(
          "div",
          { staticClass: "flex_box" },
          _vm._l(_vm.imageArray, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "imageBox",
                class: _vm.activeIndex == index ? "borderBlue" : "",
                on: {
                  click: function ($event) {
                    return _vm.handBoxImg(item, index)
                  },
                },
              },
              [
                _c("el-image", {
                  staticStyle: { width: "100px", height: "100px" },
                  attrs: { src: item.fileUrl, fit: "cover" },
                }),
              ],
              1
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }